<template>
  <div class="vertical-nav-header d-flex align-center justify-space-between ps-6 pe-5 pt-5 pb-2">
    <router-link
      to="/"
      class="d-flex align-center text-decoration-none"
    >
      <v-img
        :src="appLogo"
        eager
        contain
        class="app-logo me-2"
      ></v-img>
      <v-slide-x-transition>
        <h2
          v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
          class="app-title text--primary"
        >
          {{ appName }}
        </h2>
      </v-slide-x-transition>
    </router-link>

    <v-slide-x-transition>
      <div
        v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
        v-if="$vuetify.breakpoint.lgAndUp"
        class="d-flex align-center ms-1"
        @click.stop="menuIsVerticalNavMini = !menuIsVerticalNavMini"
      >
        <v-icon
          v-show="!menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiPin }}
        </v-icon>
        <v-icon
          v-show="menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiPinOff }}
        </v-icon>
      </div>
      <v-icon
        v-else
        size="20"
        class="d-inline-block"
        @click.stop="$emit('close-nav-menu')"
      >
        {{ icons.mdiClose }}
      </v-icon>
    </v-slide-x-transition>
  </div>
</template>

<script>
import useAppConfig from '@core/@app-config/useAppConfig'
import {
  mdiClose, mdiPin, mdiPinOff, mdiRadioboxBlank, mdiRecordCircleOutline,
} from '@mdi/js'
import themeConfig from '@themeConfig'
import {
  inject, watch, ref, onBeforeMount,
} from '@vue/composition-api'
import { EventBus } from '../../../../../../components/event-bus/event-bus'
import { useRouter } from '@/@core/utils'

export default {

  mounted() {
    EventBus.$on('close-menu', () => {
      this.menuIsVerticalNavMini = !this.menuIsVerticalNavMini
    })
  },

  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()
    const isMouseHovered = inject('isMouseHovered')

    const { route } = useRouter()
    const appName = ref(themeConfig.app.name)

    const titulo = () => {
      if (route.value.fullPath.toLocaleLowerCase().includes('vikflow')) {
        appName.value = 'VIKFLOW'
      } else {
        appName.value = themeConfig.app.name
      }
    }

    onBeforeMount(titulo)

    watch(route, () => {
      titulo()
    })

    return {
      menuIsVerticalNavMini,
      isMouseHovered,
      appName,
      appLogo: themeConfig.app.logo,

      // Icons
      icons: {
        mdiClose,
        mdiRadioboxBlank,
        mdiRecordCircleOutline,
        mdiPin,
        mdiPinOff,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  background-color: #f4f5fa;
  border-radius: 50%;
  width: 30px;
  height: 29px;
  overflow: hidden;
  position: relative;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }

  .img {
  position: absolute;
  bottom: 0;
  width: 100%;
}
}
</style>
